const EDITED_STATUS = 'edit-alert-status';
export const UNCLAIMED = 'Unclaimed';
export const CLAIMED = 'Claimed';
export const SCHEDULED = 'Scheduled';
export const CLOSED_OUT = 'Closed-Out';

export const translationMap = {
  0: 'Claim',
  1: 'Schedule',
  2: 'Close-Out',
  3: 'Complete',
};

export const modalStyle = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 500,
  bgcolor: 'background.paper',
  border: `2px solid`,
  borderColor: 'primary.main',
  boxShadow: 24,
  p: 4,
  maxHeight: '90vh',
  overflowY: 'auto',
};

export const alertStatusMap = {
  0: 'Unclaimed',
  1: 'Claimed',
  2: 'Scheduled',
  3: 'Closed-Out',
};

export const indicatorsMap = {
  isPeerRequested: 'Peer Requested',
  isTelehealth: 'Telehealth',
  isInjectable: 'Injectable',
  isMinor: 'Minor',
  isCTI: 'CTI',
  isIOP: 'IOP',
  isPROS: 'PROS',
  isPartialHospital: 'Partial Hospital',
  isOnTrack: 'OnTrack',
  isDayRehab: 'Day Rehab',
  isMAT: 'MAT',
  isOTP: 'OTP',
};

export const wasAlertUnclaimed = (actions) => {
  for (const action of actions) {
    if (action.action === EDITED_STATUS) {
      if (action.altered.from === CLAIMED && action.altered.to === UNCLAIMED) {
        return true;
      }
    }
  }
  return false;
};

export const isUnrouteable = ({ alertStatus = 2, actions }) => {
  if (alertStatus !== 2) return false;
  if (actions.length < 2) {
    return true;
  }
  const lastEntry = actions[actions.length - 1];
  if (lastEntry.altered.to === UNCLAIMED) return true;
  return false;
};
